import { Route, Routes, Navigate } from "react-router-dom";
import { entities } from "byzantine";

import { InstitutionSettingsContextProvider } from "../contexts/InstitutionSettingsContext";
import { useUserFeatures } from "../contexts/UserFeaturesContext";
import { areAchTemplatesAvailable } from "../Templates/constants";

import DualApprovalContainer from "./DualApprovalContainer";

export const DUAL_APPROVALS_ROUTE = "approvals";
export const DUAL_APPROVALS_PENDING_ROUTE = "pending";
export const DUAL_APPROVALS_TEMPLATES_PENDING_ROUTE = "templates";

const DualApprovalsRoutes = () => {
  const isBusinessUser = entities.useIsBusinessUser();
  const features = useUserFeatures();
  const achTemplatesEnabled = areAchTemplatesAvailable(features);

  if (!isBusinessUser) {
    return <Navigate to="/" replace />;
  }

  return (
    <InstitutionSettingsContextProvider>
      <Routes>
        {/* redirect /approvals -> /approvals/pending */}
        <Route
          index
          element={
            <Navigate
              to={`/${DUAL_APPROVALS_ROUTE}/${DUAL_APPROVALS_PENDING_ROUTE}`}
              replace
            />
          }
        />

        <Route
          path={`${DUAL_APPROVALS_PENDING_ROUTE}/:dualApprovalId?`}
          element={<DualApprovalContainer />}
        />

        {achTemplatesEnabled ? (
          <Route
            path={`${DUAL_APPROVALS_TEMPLATES_PENDING_ROUTE}/:dualApprovalId?`}
            element={<DualApprovalContainer />}
          />
        ) : (
          // fallback if user doesn't have access to templates - redirect to pending approvals
          <Route
            path={`${DUAL_APPROVALS_TEMPLATES_PENDING_ROUTE}/*`}
            element={
              <Navigate
                to={`/${DUAL_APPROVALS_ROUTE}/${DUAL_APPROVALS_PENDING_ROUTE}`}
                replace
              />
            }
          />
        )}

        <Route
          path="history/:dualApprovalId?"
          element={<DualApprovalContainer />}
        />
      </Routes>
    </InstitutionSettingsContextProvider>
  );
};

export default DualApprovalsRoutes;
